import { observable, action, computed } from "mobx";
import {post} from "../services/ajax.service";


class SettingStore {
  @observable blocked_ip = [];
  @observable blocked_ip_count = 0;
  @observable limit = 10;
  @observable tiles = 0;
    @action clearCache = async (data) => {
        
        try {
          let response = await post(
            "/api/v1/settingActions/clearCache"
          );
        } catch (err) {
          console.log(err);
        }
     } 

    @action groupLoaded = async (data={}) => {
        
        try {
          let response = await post(
            "/api/v1/settingActions/groupLoaded",data
          );
          return response.data;
        } catch (err) {
          console.log(err);
        }
     } 

     @action getLockedIpAddresses = async data => {
      this.blocked_ip = [];
      this.blocked_ip_count = 0;
      const response = await post(
          `/api/v1/settingActions/getLockedIpAddresses?=${this.limit}&&offset=${data.offset}&&search=${data.search}&&attr=${data.attr}`
        );
        this.blocked_ip = response.data.rows;
        this.blocked_ip_count = response.data.count;
        let count = parseInt(response.data.count);
        this.tiles =
        count % this.limit == 0
          ? parseInt(count / this.limit)
          : parseInt(count / this.limit) + 1
      }
}

export default SettingStore;
